import { ILogFilter, ILogMessage } from "../types";

/**
 * Base Filter class - defines the interface for custom Filters
 */
export class Filter implements ILogFilter {
  check(message: ILogMessage): boolean {
    throw new Error('Not Implemented');
  }
}
